<!-- Toast propio del módulo (`key="worklog"`). El <p-toast> del header queda por debajo de la
     máscara de los diálogos; este vive en el árbol del Mapa de trabajo y sí se ve sobre ellos. -->
<p-toast key="worklog" position="top-right"></p-toast>

<div class="wl-container">
  <!-- Barra: toggle de vistas + acciones -->
  <div class="wl-topbar">
    <div class="wl-subtoggle">
      <button type="button" [class.active]="view === 'backlog'" (click)="view = 'backlog'">
        <i class="fa-solid fa-list-ul"></i> Backlog
      </button>
      <button type="button" [class.active]="view === 'board'" (click)="view = 'board'">
        <i class="fa-solid fa-table-columns"></i> Tablero
      </button>
      <button type="button" [class.active]="view === 'times'" (click)="view = 'times'">
        <i class="fa-solid fa-chart-gantt"></i> Tiempos
      </button>
      <button type="button" [class.active]="view === 'history'" (click)="view = 'history'">
        <i class="fa-solid fa-box-archive"></i> Historial
      </button>
    </div>

    <div class="wl-topbar-right">
      <span class="wl-nodev" *ngIf="view === 'board' && !isDev">
        <i class="fa-solid fa-lock"></i> Solo lectura
      </span>
      <button type="button" class="wl-add" (click)="createVisible = true">
        <i class="fa-solid fa-plus"></i> Tarea
      </button>
    </div>
  </div>

  <!-- Vistas -->
  <app-worklog-backlog *ngIf="view === 'backlog'" (openItem)="openDetail($event)"></app-worklog-backlog>
  <app-worklog-board *ngIf="view === 'board'" [isDev]="isDev" (openItem)="openDetail($event)"></app-worklog-board>
  <!-- Tiempos: cuánto tardó cada implementación, épicas y trabajo suelto en el mismo eje. -->
  <div class="wl-times" *ngIf="view === 'times'">
    <app-worklog-timeline (openItem)="openDetail($event)" (openEpic)="openEpicDetail($event)"></app-worklog-timeline>
  </div>

  <app-worklog-history *ngIf="view === 'history'" (openItem)="openDetail($event)"></app-worklog-history>
</div>

<!-- Diálogos compartidos -->
<app-worklog-create-dialog [(visible)]="createVisible" (created)="onCreated()"></app-worklog-create-dialog>
<app-worklog-item-detail
  [(visible)]="detailVisible"
  [itemId]="detailId"
  [isDev]="isDev"
  (changed)="onDetailChanged()"></app-worklog-item-detail>

<!-- La ficha de épica NO cierra al abrir una tarea desde ella: se entra a la épica para recorrer
     su desglose, y cerrarla en cada tarea obligaría a volver a abrirla para la siguiente. -->
<app-worklog-epic-detail
  [(visible)]="epicVisible"
  [row]="epicRow"
  [isDev]="isDev"
  (changed)="onEpicChanged()"
  (openItem)="openDetail($event)"></app-worklog-epic-detail>
